import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export const deleteAnnouncement = async (id: string) => {
  const [response, bodyOrError] = await Api.delete(`announcement/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useDeleteAnnouncement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'deleteAnnouncement',
    (id: string) => {
      return deleteAnnouncement(id);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getAnnouncement']);
        queryClient.invalidateQueries(['getAnnouncementsByPage']);
        setAlertSnackbar({
          message: 'Announcement deleted successfully',
          severity: 'success',
          vertical: 'top',
        });
        navigate('/cms/announcements');
      },
    },
  );
};
